<div class="multilingual-modal">
  <h2 md-dialog-title>Multilingual edition</h2>
  <md-dialog-content>
    <app-spinner *ngIf="loading"></app-spinner>
    <md2-tabs
      *ngIf="
        (data.sportingEventId || (translations && translations.length > 0)) &&
        !loading
      "
    >
      <md2-tab
        *ngFor="let item of translations | objectToArray"
        [label]="item.fieldName ? item.fieldName : ''"
      >
        <table *ngIf="partials">
          <thead>
            <tr>
              <th>Language</th>
              <th class="lock-table-head">Lock</th>
              <th>{{ item.fieldName }}</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let translation of partials[item.fieldName]">
              <td>{{ translation.language }}</td>
              <td class="cursor-pointer">
                <md-icon
                  *ngIf="translation.displayLocked"
                  (click)="
                    toggleLockTranslation(translation, item.fieldName, false)
                  "
                  >lock</md-icon
                >
                <md-icon
                  *ngIf="!translation.displayLocked"
                  (click)="
                    toggleLockTranslation(translation, item.fieldName, true)
                  "
                  >lock_open</md-icon
                >
              </td>
              <td *ngIf="item.inputType === 'Text'">
                <input
                  mdInput
                  [(ngModel)]="translation.display"
                  (keydown)="valueChanged(translation, item.fieldName)"
                />
              </td>
              <td *ngIf="item.inputType === 'Html'">
                <textarea
                  mdInput
                  [(ngModel)]="translation.display"
                  rows="5"
                  (keydown)="valueChanged(translation, item.fieldName)"
                >
></textarea
                >
              </td>
              <td>
                <md-icon
                  mdTooltip="Duplicate for all"
                  *ngIf="!translation.selectable && !translation.source"
                  class="cursor-pointer"
                  (click)="duplicate(item.fieldName, translation.language)"
                >
                  content_copy
                </md-icon>
                <md-icon
                  mdTooltip="Duplicate to empty"
                  *ngIf="!translation.selectable && !translation.source"
                  class="cursor-pointer"
                  (click)="
                    duplicateToEmpty(item.fieldName, translation.language)
                  "
                >
                  copy_all
                </md-icon>
                <md-icon
                  mdTooltip="Copy"
                  *ngIf="!translation.selectable && !translation.source"
                  class="cursor-pointer"
                  (click)="copyText(item.fieldName, translation.language)"
                >
                  file_copy
                </md-icon>
                <div *ngIf="translation.source">
                  <md-icon
                    class="cursor-pointer apply"
                    (click)="
                      applyDuplicate(item.fieldName, translation.language)
                    "
                    mdTooltip="Apply"
                    >check_circle</md-icon
                  >
                  <md-icon
                    class="cursor-pointer cancel"
                    (click)="
                      cancelDuplicate(item.fieldName, translation.language)
                    "
                    mdTooltip="Cancel"
                    >cancel</md-icon
                  >
                </div>
                <md-checkbox
                  *ngIf="translation.selectable"
                  [(ngModel)]="translation.checked"
                  (change)="recheckDuplicate(translation, $event)"
                ></md-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </md2-tab>
      <md2-tab label="Pictures">
        <table *ngIf="partialsPicture">
          <thead>
            <tr>
              <th>Language</th>
              <th *ngIf="!data.sportingEventId">Lock</th>
              <th>Original</th>
              <th>16:9</th>
              <th>4:3</th>
              <th>3:4</th>
              <th>140:303</th>
              <th>10:3</th>
              <th>1:1</th>
              <th>2:3</th>
              <th>485:173</th>
              <th>Duplicate</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let picture of partialsPicture">
              <td>{{ picture.language.value }}</td>
              <td class="cursor-pointer" *ngIf="!data.sportingEventId">
                <md-icon
                  *ngIf="picture.displayLocked"
                  (click)="toggleLockPicture(picture, false)"
                  >lock</md-icon
                >
                <md-icon
                  *ngIf="!picture.displayLocked"
                  (click)="toggleLockPicture(picture, true)"
                  >lock_open</md-icon
                >
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, 'Original')"
                  [src]="
                    getETTPictureByFormat(picture, 'Original').blob ||
                    getETTPictureByFormat(picture, 'Original').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, '16:9')"
                  [src]="
                    getETTPictureByFormat(picture, '16:9').blob ||
                    getETTPictureByFormat(picture, '16:9').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, '4:3')"
                  [src]="
                    getETTPictureByFormat(picture, '4:3').blob ||
                    getETTPictureByFormat(picture, '4:3').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, '3:4')"
                  [src]="
                    getETTPictureByFormat(picture, '3:4').blob ||
                    getETTPictureByFormat(picture, '3:4').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, '140:303')"
                  [src]="
                    getETTPictureByFormat(picture, '140:303').blob ||
                    getETTPictureByFormat(picture, '140:303').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, '10:3')"
                  [src]="
                    getETTPictureByFormat(picture, '10:3').blob ||
                    getETTPictureByFormat(picture, '10:3').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, '1:1')"
                  [src]="
                    getETTPictureByFormat(picture, '1:1').blob ||
                    getETTPictureByFormat(picture, '1:1').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, '2:3')"
                  [src]="
                    getETTPictureByFormat(picture, '2:3').blob ||
                    getETTPictureByFormat(picture, '2:3').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <img
                  *ngIf="getETTPictureByFormat(picture, '485:173')"
                  [src]="
                    getETTPictureByFormat(picture, '485:173').blob ||
                    getETTPictureByFormat(picture, '485:173').pictureURL
                  "
                  height="50"
                />
              </td>
              <td>
                <md-icon
                  mdTooltip="Duplicate for all"
                  *ngIf="!picture.selectable && !picture.source"
                  class="cursor-pointer"
                  (click)="duplicatePicture(picture)"
                >
                  content_copy
                </md-icon>
                <md-icon
                  mdTooltip="Duplicate to empty"
                  *ngIf="!picture.selectable && !picture.source"
                  class="cursor-pointer"
                  (click)="duplicateEmptyPicture(picture)"
                >
                  copy_all
                </md-icon>
                <md-icon
                  mdTooltip="Copy"
                  *ngIf="!picture.selectable && !picture.source"
                  class="cursor-pointer"
                  (click)="copyPicture(picture)"
                >
                  file_copy
                </md-icon>
                <div *ngIf="picture.source">
                  <md-icon
                    class="cursor-pointer apply"
                    (click)="applyDuplicatePicture()"
                    mdTooltip="Apply"
                    >check_circle
                  </md-icon>
                  <md-icon
                    class="cursor-pointer cancel"
                    (click)="cancelDuplicatePicture()"
                    mdTooltip="Cancel"
                    >cancel
                  </md-icon>
                </div>
                <md-checkbox
                  *ngIf="picture.selectable"
                  [(ngModel)]="picture.checked"
                  (change)="checkDuplicatePicture(picture, $event)"
                ></md-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </md2-tab>
    </md2-tabs>
  </md-dialog-content>
  <md-dialog-actions>
    <div class="actions">
      <button md-raised-button (click)="cancel()">
        <md-icon>cancel</md-icon>
        Cancel
      </button>
      <button
        md-raised-button
        color="primary"
        (click)="apply()"
        [disabled]="applyPending"
      >
        <md-icon>check</md-icon>
        Apply
      </button>
    </div>
  </md-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/multilingual-modal/multilingual-modal.component.html